export const loggerMiddleware = () => next => action => {
  console.info(action.type);
  next(action);
};
